import React, {Component} from 'react';
import {Grid, Header, Icon, List, Popup} from 'semantic-ui-react';

class PlanPopup extends Component {

    render() {

        return (
            <Popup
                trigger={<Icon link name='info circle' />}
                flowing
                hoverable
            >
                <Grid centered divided columns={1}>
                    <Grid.Column textAlign='center'>
                        <Header as='h4' textAlign={'center'} className={'titlePrice'}>{this.props.plan.name}</Header>
                        <List divided relaxed>
                            {
                                this.props.plan.descriptions.map(function(description, index) {
                                    return (
                                        <List.Item key={index}>
                                            <List.Content>
                                                <List.Header><Icon name='check'/>{description}</List.Header>
                                            </List.Content>
                                        </List.Item>
                                    )
                                })
                            }
                        </List>
                    </Grid.Column>
                </Grid>
            </Popup>
        );
    }
}
export default PlanPopup;



// WEBPACK FOOTER //
// ./src/components/settings/PlanPopup.js